export const numberFormatted = () => (value) => new Intl.NumberFormat('en').format(value);
